class Voice {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const modalTrigger = document.querySelectorAll(".js-voice-modal")
    const modalContainer = document.querySelector(".js-voice-modal-container")
    const modalOverlay = document.querySelector(".js-voice-modal-overlay")
    const modalClose = document.querySelector(".modal-close")

    //モーダル要素
    const modalImgPath = document.querySelector(".js-modal-imgPath")
    const modalTime = document.querySelector(".js-modal-time")
    const modalInfo01 = document.querySelector(".js-modal-info01")
    const modalInfo02 = document.querySelector(".js-modal-info02")
    const modalPaper = document.querySelector(".js-modal-paper")
    const modalCourse = document.querySelector(".js-modal-course")
    const modalVoice = document.querySelector(".js-modal-voice")
    const body = document.querySelector("body")

    modalTrigger.forEach(trigger => {

      trigger.addEventListener("click", () => {

        const imgPath = trigger.querySelector("img").getAttribute('src');

        modalImgPath.setAttribute('src', imgPath);
        modalTime.textContent = trigger.querySelector(".js-time").textContent
        modalInfo01.textContent = trigger.querySelector(".js-info01").textContent
        modalInfo02.textContent = trigger.querySelector(".js-info02").textContent
        modalPaper.textContent = trigger.querySelector(".js-paper").textContent
        modalCourse.textContent = trigger.querySelector(".js-course").textContent
        modalVoice.textContent = trigger.querySelector(".js-voice").textContent

        body.classList.add("no_scroll")

        modalContainer.classList.add("is-active")
        modalOverlay.classList.add("is-active")

      })

    })

    if(modalClose){
      modalClose.addEventListener("click", () => {
        modalContainer.classList.remove("is-active")
        modalOverlay.classList.remove("is-active")
        body.classList.remove("no_scroll")
      })
    }

    modalOverlay.addEventListener("click", () => {
      modalContainer.classList.remove("is-active")
      modalOverlay.classList.remove("is-active")
      body.classList.remove("no_scroll")
    })


  }
}